export default __webpack_public_path__ + "static/media/prev-Marine-Receiver-3.3e4881e4.png";